import {
	BOOKINGS_LOADING,
	CLEAR_BOOKINGS,
	SET_BOOKINGS,
	SET_SELECTED_ROOMSTAY,
	SET_SINGLE_BOOKING,
	TOGGLE_BOOKING_FAILED,
} from '../actionTypes';
import api from "../../api/api";
import {openNotificationWithIcon} from "../notificationService";

export function initApp() {
	return dispatch => {
		dispatch(toggleBookingsLoading(true));
		dispatch(toggleBookingsFailed(false));

		api.get('bookings', {data: null})
			.then(
                response => {
                    if(response !== undefined && response.data !== undefined && response.data.content !== undefined) {
                        dispatch(setBookings(response.data.content));
                        dispatch(setSingleBooking(response.data.content && response.data.content.length > 0 ? response.data.content[0].uuid : false));
						dispatch(setSelectedRoomStayUUID(response.data.content && response.data.content.length > 0 && response.data.content[0].roomStayUUID !== undefined ? response.data.content[0].roomStayUUID : false));
                        dispatch(toggleBookingsLoading(false));
                        dispatch(toggleBookingsFailed(false));
                    }
				})
			.catch(error => {
			    if(error !== undefined && error.response !== undefined && error.response.status !== undefined && error.response.status === 426) {
			        return;
                }
				dispatch(toggleBookingsFailed(true));
				if(error && error.response && error.response.status !== 403) {
					openNotificationWithIcon('error', 'Error', 'There has been an error processing your request, please try again.');
				}
			})
			.then(() => {
				dispatch(toggleBookingsLoading(false));
			});
	};
}

export function setBookings(data) {
	return {
		type: SET_BOOKINGS,
		data
	}
}


export function setSingleBooking(bookingId, history = false, route) {
	return {
		type: SET_SINGLE_BOOKING,
		bookingId,
		history,
		route
	}
}

export function setSelectedRoomStayUUID(roomstayUUID) {
	return {
		type: SET_SELECTED_ROOMSTAY,
		roomstayUUID
	}
}

export function clearBookings() {
	return {
		type: CLEAR_BOOKINGS
	}
}

export function toggleBookingsLoading(toggle) {
	return {
		type: BOOKINGS_LOADING,
		toggle
	}
}

export function toggleBookingsFailed(failed) {
	return {
		type: TOGGLE_BOOKING_FAILED,
		failed
	}
}
